var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'd-inline-block': _vm.inlineBlock,
    'd-block': !_vm.inlineBlock,
  }},[(_vm.wait)?_c('v-skeleton-loader',{class:{
      'd-inline-block': _vm.inlineBlock,
      'd-block': !_vm.inlineBlock,
    },attrs:{"type":_vm.type}}):(!_vm.aclValid)?_vm._t("invalidAcl",function(){return [_c('standard-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.alertMessage)+" ")])]}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }